module.exports = __webpack_public_path__ + "img/1_versace.d40d2f6a.jpg";